<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title h5">{{ questionID + 1 }} – {{ question.title }}</div>
      <div class="card-subtitle text-gray">{{ question.type }}</div>
    </div>
    <div class="card-body">
      <ol class="float-left list-decimal list-inside">
        <li v-for="(answer, aid) in question.options"
            :class="aid === question.correct && question.type === QUESTION_TYPES.KNOWLEDGE && 'text-green-600 font-bold'">
          {{ answer }}
        </li>
      </ol>

      <img v-if="mediaObject && mediaObject.meta.contentType.startsWith('image/')" :src="mediaObject.url" alt="Visual"
           class="w-1/3 float-right" />
      <video v-if="mediaObject && mediaObject.meta.contentType.startsWith('video/')" :src="mediaObject.url"
             class="bg-black w-1/3 float-right" controls />

    </div>
    <div v-if="allowEdit" class="card-footer">
      <div class="btn-group">
        <button class="btn btn-primary" @click="$router.push(`/e/${quiz.id}/${questionID}`)">Bearbeiten</button>
        <button class="btn" @click="deleteQuestion">Löschen</button>
      </div>
    </div>
  </div>
</template>
<script>
import { QUESTION_TYPES } from "../../views/EditQuiz";
import { injectComponentWithReturn } from "../../main";
import { quizCollection } from "../../plugins/firebase";
import firebase from "firebase/app";
import ConfirmPopup, { deleteQuestion } from "../ConfirmPopup";
import { logDBError } from "../../store";

export default {
  props: ["questionID", "quiz", "allowEdit"],
  methods: {
    deleteQuestion() {
      injectComponentWithReturn(ConfirmPopup, {
        question: deleteQuestion("Frage", true),
        confirm: "Löschen"
      }).then(() => {
        quizCollection.doc(this.quiz.id).update({
          questions: firebase.firestore.FieldValue.arrayRemove(this.question),
        }).catch(logDBError(this.$store, "Frage konnte nicht gelöscht werden. "));
      });
    }
  },
  computed: {
    mediaObject() {
      return this.$store.state.media.mediaFiles.filter(file => file.ref.fullPath === this.question.media)[0];
    },
    question() {
      return this.quiz.questions[this.questionID];
    }
  },
  data() {
    return {
      QUESTION_TYPES
    }
  },
}
</script>